import { useEffect, useState, memo } from "react";
import { Bar } from "react-chartjs-2";
import { http } from "../helper";
import { BaseUrl } from "../common/config";
import Chart from "chart.js/auto";
import { CategoryScale } from "chart.js";
import DatePicker from "react-datepicker";
import { format, sub } from "date-fns";
import { useTranslation } from "react-i18next";
Chart.register(CategoryScale);

export const DepotTopBottomSellingProducts = memo(({}) => {
  const { t } = useTranslation();
  var currentTime = new Date();
  var currentyear = currentTime.getFullYear();
  var currentMonth = currentTime.getUTCMonth() + 1;
  const [filter, setFilter] = useState(0);
  const [catFilter, setCatFilter] = useState(0);
  const [filtertext, setFilterText] = useState("");
  const [isLoading, setIsLoading] = useState(true);
  const [showDatePicker, setShowDatePicker] = useState(false);
  const [fromDate, setFromDate] = useState(null);
  const [toDate, setToDate] = useState(null);
  const getCurrentFiscalYear = () => {
    const today = new Date();
    const year = today.getFullYear();
    const month = today.getMonth() + 1;
    // Fiscal year starts in September
    const startYear = month >= 9 ? year : year - 1;
    const endYear = startYear + 1;
    return `${startYear}-${endYear}`;
  };
  const [period, setPeriod] = useState(getCurrentFiscalYear());
  const [months, setMonths] = useState("9");
  const [quarter, setQuarter] = useState("");
  const [mainDepot, setMainDepot] = useState("");
  const [subDepotList, setSubDepotList] = useState([]);
  const [mainDepotList, setMainDepotList] = useState([]);
  const [topSellingProducts, setTopSellingProducts] = useState([]);
  const [depots, setDepots] = useState([]);
  const [subDepot, setSubDepot] = useState("");
  const MonthNames = [
    t("months.sep"),
    t("months.oct"),
    t("months.nov"),
    t("months.dec"),
    t("months.jan"),
    t("months.feb"),
    t("months.mar"),
    t("months.apr"),
    t("months.may"),
    t("months.jun"),
    t("months.jul"),
    t("months.aug"),
  ];
  const currentFiscalMonth = new Date().getMonth(); // 0-indexed: Jan = 0, Apr = 3, Sep = 8

  const quarterNames = {
    1: t("quarter_sep_nov"),
    2: t("quarter_dec_feb"),
    3: t("quarter_mar_may"),
    4: t("quarter_jun_aug"),
  };

  const priceFormat = (price) => {
    return price.toLocaleString("en-US", {
      style: "currency",
      currency: "GBP",
      minimumFractionDigits: 2,
    });
  };

  const getCurrentFiscalQuarter = () => {
    const month = new Date().getMonth() + 1; // 1–12
    if (month >= 9 && month <= 11) return 1; // Sep–Nov
    if (month === 12 || month <= 2) return 2; // Dec–Feb
    if (month >= 3 && month <= 5) return 3; // Mar–May
    return 4; // Jun–Aug
  };

  const getAvailableQuarters = (selectedFiscalYear) => {
    const currentFiscalYear = getCurrentFiscalYear();
    const currentQuarter = getCurrentFiscalQuarter();
    return Object.entries(quarterNames)
      .filter(([quarterNumber]) => {
        if (selectedFiscalYear === currentFiscalYear) {
          return Number(quarterNumber) <= currentQuarter;
        }
        return true; // show all for past years
      })
      .map(([quarterNumber, label]) => (
        <option key={quarterNumber} value={quarterNumber}>
          {label}
        </option>
      ));
  };

  useEffect(() => {
    const now = new Date();
    const month = now.getMonth() + 1;
    const fiscalQuarterMap = {
      9: 1,
      10: 1,
      11: 1,
      12: 2,
      1: 2,
      2: 2,
      3: 3,
      4: 3,
      5: 3,
      6: 4,
      7: 4,
      8: 4,
    };
    const currentFiscalQuarter = fiscalQuarterMap[month];
    setQuarter(currentFiscalQuarter);
  }, []);

  const [reportType, setReportType] = useState("desc");

  const DateChange = (value, type) => {
    if (type === "from") {
      setFromDate(value);
      if (toDate && value && value > toDate) {
        setToDate(null);
      }
    } else if (type === "to") {
      if (!fromDate || value >= fromDate) {
        setToDate(value);
      } else {
        // Handle invalid date selection
        setToDate(null);
      }
    }
  };
  // Custom plugin to display "No data found"
  const noDataPlugin = {
    id: "noDataPlugin",
    beforeDraw: (chart) => {
      const { datasets } = chart.data;
      const hasData = datasets.some((dataset) =>
        dataset.data.some((val) => val > 0),
      );
      if (!hasData) {
        const ctx = chart.ctx;
        const { width, height } = chart;
        ctx.save();
        ctx.textAlign = "center";
        ctx.textBaseline = "middle";
        ctx.font = "16px Arial";
        ctx.fillStyle = "#eb9f9d";
        ctx.fillText(t("no_data_filtered_search_txt"), width / 2, height / 2);
        ctx.restore();
      }
    },
  };

  const [topSellerChartData, setTopSellerChartData] = useState({
    labels: [],
    datasets: [
      {
        label: t("top_selling_products_txt"),
        data: [],
        backgroundColor: ["rgba(252,194,84,1)", "#f4ecec"],
        borderColor: "#e6e6e6",
        borderWidth: 2,
      },
    ],
  });

  useEffect(() => {
    let URL = BaseUrl + `admin/getdepots`;
    http
      .get(URL)
      .then((response) => {
        let responseData = response.data.data;
        const uniqueDepots = Array.from(
          new Set(responseData.map((item) => item.mainDepot)),
        ).map((mainDepot) =>
          responseData.find((item) => item.mainDepot === mainDepot),
        );
        setSubDepotList(responseData);
        setDepots(responseData);
        setMainDepotList(uniqueDepots);
      })
      .catch((err) => {
        console.log(err);
      });
  }, []);

  useEffect(() => {
    if (mainDepot === "") {
      setSubDepotList(depots);
    } else {
      setSubDepotList(depots.filter((item) => item.mainDepot === mainDepot));
    }
  }, [mainDepot, mainDepotList]);

  useEffect(() => {
    if (filter === "custom" && (!fromDate || !toDate)) {
      // Don't make the API call if dates are missing for the "custom" filter
      return;
    }
    let URL1 = BaseUrl + "admin/gettopbottomsellingproducts";
    let payload = {};
    if (filter === "custom") {
      payload = {
        filter: filter,
        datefrom: format(new Date(fromDate), "yyyy-MM-dd"),
        category: catFilter,
        dateto: format(new Date(toDate), "yyyy-MM-dd"),
        mainDepot: mainDepot,
        subDepot: subDepot,
        sort: reportType,
      };
      setShowDatePicker(false);
    } else if (["weekly", "monthly", "quarterly", "FYdata"].includes(filter)) {
      payload = {
        filter: filter,
        category: catFilter,
        datefrom: "",
        dateto: "",
        period: period,
        mainDepot: mainDepot,
        subDepot: subDepot,
        sort: reportType,
      };
    } else {
      payload = {
        filter: parseInt(filter),
        datefrom: "",
        dateto: "",
        category: catFilter,
        mainDepot: mainDepot,
        subDepot: subDepot,
        sort: reportType,
      };
    }
    setIsLoading(true);
    http
      .post(URL1, payload)
      .then((response) => {
        setIsLoading(false);
        const actualMonth = parseInt(months);
        let filteredData = [];
        if (filter === "monthly") {
          filteredData = response.data.data.filter(
            (item) => item.month === actualMonth,
          );
        } else if (filter === "quarterly") {
          filteredData = response.data.data.filter(
            (item) => item.fiscalQuarter === quarter,
          );
        } else {
          filteredData = response.data.data.filter((item) => item.sum > 0);
        }
        setTopSellingProducts(filteredData);
        setTopSellerChartData({ labels: [], datasets: [] });
        setTopSellerChartData({
          labels: filteredData.map(
            (item) =>
              item.ProductNumber +
              "~" +
              fixDescription(item.Description) +
              "~" +
              item.categoryId,
          ),
          datasets: [
            {
              label: t("quantity_ordered"),
              data: filteredData.map((item) => item.sum),
              backgroundColor: ["#8dc5e4", "#1b81bc"],
              borderColor: "#E5E5E5",
              borderWidth: 0,
              barThickness: 25,
              maxBarThickness: 40,
              borderRadius: 4,
            },
          ],
        });
      })
      .catch((err) => {
        console.log(err);
      });
  }, [filter, fromDate, toDate, catFilter, months, quarter, period, mainDepot, subDepot, reportType]);

  const changeMainDepotHandler = (e) => {
    setSubDepot("");
    setMainDepot(e.target.value);
  };

  const changeSubDepotHandler = (e) => {
    setSubDepot(e.target.value);
  };

  const changeCatFilterHandler = (e) => {
    setCatFilter(e.target.value);
    setShowDatePicker(false);
  };

  const changePeriodHandler = (e) => {
    const newPeriod = e.target.value;
    setPeriod(newPeriod); // update selected fiscal year in state
    //split fiscal year
    const [newStartYear, newEndYear] = newPeriod.split("-").map(Number);
    const fiscalStartMonthIndex = 8; // 0-based index for September
    const today = new Date();
    const currentFiscalYear = getCurrentFiscalYear();
    //compare sleted year with currentfiscalyear
    const isCurrentFiscalYear = newPeriod === currentFiscalYear;
    // MONTHLY filter logic
    if (filter === "monthly") {
      let visibleMonthNames = MonthNames;
      if (isCurrentFiscalYear) {
        // Calculate current fiscal month index
        const currentMonthIndex = today.getMonth(); // 0-based
        const monthsPassedSinceFiscalStart =
          (currentMonthIndex - fiscalStartMonthIndex + 12) % 12;
        const maxVisibleIndex = monthsPassedSinceFiscalStart;
        visibleMonthNames = MonthNames.slice(0, maxVisibleIndex + 1);
      }
      const selectedMonthIndex = MonthNames.indexOf(months);
      const isValidMonth =
        selectedMonthIndex >= 0 &&
        selectedMonthIndex < visibleMonthNames.length;
      if (!isValidMonth) {
        const defaultMonthNumber = ((0 + fiscalStartMonthIndex) % 12) + 1;
        setMonths(String(defaultMonthNumber));
      }
    }
    // QUARTERLY filter logic
    if (filter === "quarterly") {
      const currentQuarter = getCurrentFiscalQuarter();
      let maxQuarter = 4;
      if (isCurrentFiscalYear) {
        maxQuarter = currentQuarter;
      }
      if (parseInt(quarter) > maxQuarter) {
        setQuarter(maxQuarter > 0 ? String(maxQuarter) : "1");
      }
    }
  };

  const changeMonthHandler = (e) => {
    setMonths(e.target.value);
  };

  const changeFilterHandler = (e) => {
    setFilter(e.target.value);
    setFilterText(e.target.options[e.target.selectedIndex].text);
    if (e.target.value === "custom") {
      setShowDatePicker(true);
    } else {
      setShowDatePicker(false);
      setFromDate(null);
      setToDate(null);
      setFilter(e.target.value);
    }
  };

  const changeHandler = (e) => {
    setReportType(e.target.value);
  };

  const options = [];
  for (let i = currentyear; i >= 2023; i--) {
    if (i === currentyear && currentMonth < 9) {
      continue;
    }
    const year = i;
    options.push(
      <option value={year + "-" + (year + 1)}>
        {year + "-" + (year + 1)}
      </option>,
    );
  }

  const formatDate = (dateString) => {
    const dateObject = new Date(dateString);
    const year = dateObject.getFullYear();
    const month = String(dateObject.getMonth() + 1).padStart(2, "0");
    const day = String(dateObject.getDate()).padStart(2, "0");
    return `${day}/${month}/${year}`;
  };

  const currentFiscalYear = getCurrentFiscalYear();
  let visibleMonthNames = MonthNames;
  if (period === currentFiscalYear) {
    // Limit to current fiscal month
    const fiscalIndex = (new Date().getMonth() - 8 + 12) % 12; // Sep=0, Oct=1, ... Aug=11
    visibleMonthNames = MonthNames.slice(0, fiscalIndex + 1);
  }

  function fixDescription(description) {
    const textarea = document.createElement("textarea");
    textarea.innerHTML = description;
    let decoded = textarea.value;
    decoded = decoded
      .replace(/&apos;/g, "'")
      .replace(/apos;/g, "'")
      .replace(/&quot;/g, '"')
      .replace(/quot;/g, '"')
      .replace(/&amp;/g, "&")
      .replace(/amp;/g, "&");
    return decoded;
  }

  let loadingbuffer = isLoading ? "loading-buffer" : "";

  return (
    <div className={`chart-container chart-revenue ${loadingbuffer}`}>
      <div className="chart-Hdr">
        <h2 style={{ textAlign: "left" }}>
          {reportType === "desc"
            ? t("top_20_selling_products")
            : t("bottom_20_selling_products")}
          {"  "}
        </h2>
        <div className="chart-fltr">
          {
            <select
              style={{}}
              value={reportType}
              onChange={(e) => changeHandler(e)}
            >
              <option value={"desc"}>{t("top_20_selling_products")}</option>
              <option value={"asc"}>{t("bottom_20_selling_products")}</option>
            </select>
          }
          <div className="chart-fltr">
            {
              <select
                name="mainDepot"
                onChange={(e) => changeMainDepotHandler(e)}
              >
                <option value="">{t("select_main_depot_txt")}</option>
                {mainDepotList.map((item) => (
                  <option key={item.mainDepot} value={item.mainDepot}>
                    {item.mainDepot}
                  </option>
                ))}
              </select>
            }
          </div>
          <div className="chart-fltr">
            {
              <select
                name="subDepot"
                onChange={(e) => changeSubDepotHandler(e)}
              >
                <option value="">{t("select_local_depot_txt")}</option>
                {subDepotList.map((item) => (
                  <option key={item.subDepot} value={item.subDepot}>
                    {item.subDepot}
                  </option>
                ))}
              </select>
            }
          </div>
          <div className="chart-fltr">
            {
              <select
                value={catFilter}
                onChange={(e) => changeCatFilterHandler(e)}
              >
                <option value={"all"}>{t("all_txt")}</option>
                <option value={"pizza"}>{t("categories.pizza")}</option>
                <option value={"pasta-rice-noodle-sauces"}>
                  {t("categories.pasta_rice_noodle_sauces")}
                </option>
                <option value={"desserts"}>{t("categories.desserts")}</option>
              </select>
            }
          </div>
          <div
            className="chart-fltr"
            onMouseEnter={() => {
              if (filter === "custom" && !showDatePicker) {
                setShowDatePicker(true);
              }
            }}
            onMouseLeave={() => {
              if (filter === "custom" && showDatePicker) {
                setShowDatePicker(false);
              }
            }}
          >
            {
              <select value={filter} onChange={(e) => changeFilterHandler(e)}>
                <option value={0}>{t("all_txt")}</option>
                <option value={1}>{t("past_1_day_txt")}</option>
                <option value={"weekly"}>{t("current_week_txt")}</option>
                <option value={"monthly"}>{t("monthly_txt")}</option>
                <option value={"quarterly"}>{t("quarterly_txt")}</option>
                <option value={"FYdata"}>{t("fy_data_txt")}</option>
                <option value={30}>{t("past_30_days_txt")}</option>
                <option value={90}>{t("past_90_days_txt")}</option>
                <option value={180}>{t("past_180_days_txt")}</option>
                <option value={365}>{t("past_1_year_txt")}</option>
                <option value={"custom"}>{t("custom_date_txt")}</option>
              </select>
            }
            {showDatePicker && (
              <div className="date-picker-container">
                <label>{t("from_label_txt")}</label>
                <DatePicker
                  selected={fromDate}
                  onChange={(date) => DateChange(date, "from")}
                  showDisabledMonthNavigation
                  dateFormat="dd/MM/yyyy"
                  disablePast={true}
                  maxDate={new Date()}
                  placeholderText={t("select_date_txt")}
                />
                <label>{t("to_label_txt")}</label>
                <DatePicker
                  selected={toDate}
                  showDisabledMonthNavigation
                  dateFormat="dd/MM/yyyy"
                  onChange={(date) => DateChange(date, "to")}
                  disablePast={true}
                  maxDate={new Date()}
                  placeholderText={t("select_date_txt")}
                />
              </div>
            )}
            {filter === "quarterly" && (
              <select
                style={{ width: "160px" }}
                value={quarter}
                onChange={(e) => setQuarter(Number(e.target.value))}
              >
                {getAvailableQuarters(period)}
              </select>
            )}
            {filter === "monthly" && (
              <select
                style={{ width: "50px" }}
                value={months}
                onChange={(e) => changeMonthHandler(e)}
              >
                {visibleMonthNames.map((monthName, index) => {
                  const monthNumber = ((index + 8) % 12) + 1; // fiscal-to-calendar month number
                  return (
                    <option key={monthNumber} value={monthNumber}>
                      {monthName}
                    </option>
                  );
                })}
              </select>
            )}
            {(filter === "monthly" ||
              filter === "quarterly" ||
              filter === "FYdata") && (
              <select
                style={{ width: "170px" }}
                value={period}
                onChange={(e) => changePeriodHandler(e)}
              >
                {options}
              </select>
            )}
          </div>
        </div>
        <div className="fltr-sub-val">
          {topSellingProducts.length > 0 && (
            <span className="fltr-val">
              {t("total_revenue_excl_vat_txt")}{" "}
              <strong>
                {priceFormat(
                  topSellingProducts.reduce(
                    (acc, item) =>
                      item.revenue > 0 ? acc + item.revenue : acc,
                    0,
                  ),
                )}
              </strong>
              {[
                t("current_week_txt"),
                t("monthly_txt"),
                t("quarterly_txt"),
                t("fy_data_txt"),
              ].includes(filtertext)
                ? ""
                : filtertext != "" && filtertext != t("custom_date_txt")
                  ? " (" + filtertext + ")"
                  : filtertext === t("custom_date_txt") && fromDate && toDate
                    ? " (" +
                      formatDate(fromDate) +
                      " - " +
                      formatDate(toDate) +
                      ")"
                    : " (" + t("all_txt") + ")"}
            </span>
          )}
        </div>
      </div>
      {topSellerChartData && (
        <Bar
          data={topSellerChartData}
          plugins={[noDataPlugin]}
          options={{
            scales: {
              y: {
                grid: {
                  color: "rgba(247, 243, 241, 0.8)",
                },
                ticks: {
                  color: "rgba(207, 208, 211, 1)",
                },
              },
              x: {
                barPercentage: 0.5, // Width of bars relative to available space (0.0 - 1.0)
                categoryPercentage: 0.8, // Space between bars in a group (0.0 - 1.0)
                grid: {
                  color: "rgba(247, 243, 241, 0.8)",
                },
                ticks: {
                  color: "rgba(207, 208, 211, 1)",
                  autoSkip: false, // Show all dates
                  maxRotation: 60, // Keep labels readable
                  minRotation: 60,
                  callback: function (value, index, ticks) {
                    const label = this.getLabelForValue(value); // Get the label for the current tick
                    if (typeof label === "string" && label.includes("~")) {
                      const [productNumber, productName, ProductCategory] =
                        label.split("~"); // Split by the comma separator
                      return productNumber.replace("_TPDUPBU", ""); // Return the label with a newline
                    }
                    return label.replace("_TPDUPBU", ""); // Single-line label for other cases
                  },
                },
              },
            },
            responsive: true,
            layout: {
              padding: {
                top: 20,
                right: 0,
                bottom: 0,
                left: 0,
              },
            },
            plugins: {
              title: {
                display: false,
                text: t("top_20_selling_products"),
              },
              legend: {
                display: false,
              },
              tooltip: {
                titleColor: "rgba(220, 222, 226, 1)",
                bodyColor: "rgba(220, 222, 226, 1)",
                callbacks: {
                  title: function (tooltipItems) {
                    const originalLabel = tooltipItems[0].label;
                    const [productNumber, productName, ProductCategory] =
                      originalLabel.split("~");
                    const category =
                      ProductCategory === "1"
                        ? t("categories.pizza")
                        : ["10", "13", "11", "12"].includes(ProductCategory)
                          ? t("categories.pasta_rice_noodle_sauces")
                          : ProductCategory === "14"
                            ? t("categories.desserts")
                            : "";
                    return `${productNumber.replace("_TPDUPBU", "")} - ${productName} (${category})`;
                  },
                  label: function (tooltipItem) {
                    const index = tooltipItem.dataIndex;
                    const item = topSellingProducts[index];
                    if (!item) return "";
                    const quantity = tooltipItem.raw;
                    return [
                      `${t("quantity_ordered")}: ${quantity}`,
                      `${t("main_local_depot")}: ${item.mainDepot} / ${item.subDepot}`,
                    ];
                  },
                },
              },
              datalabels: {
                display: false,
                font: {
                  size: 11,
                  weight: "600",
                },
                padding: 5,
                anchor: "end",
                align: "top",
                formatter: function (value) {
                  return value;
                },
              },
            },
          }}
        />
      )}
    </div>
  );
});
